import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IPinResponse } from '@core/entities/skia/PinResponse'
import { Pin } from '@core/entities/skia/Pin'

export class PinResponse extends Entity<IPinResponse> {
  locationPlanId: number
  planId?: number
  droppedPins: Pin[]

  public static new(payload: IPinResponse): PinResponse {
    return plainToInstance(PinResponse, payload)
  }
}
